define('_',[],function () {
    return this._;
});
